module.exports = __webpack_public_path__ + "static/media/operational.868190fe.svg";